/* House of Reena — site chrome (cart drawer, interactions)
   Header + footer are rendered by Liquid sections.
   This file handles: cart drawer open/close, add-to-cart, qty updates, live re-render.
*/
(function () {
  "use strict";

  const SELECTORS = {
    drawer: "[data-cart-drawer]",
    backdrop: "[data-cart-backdrop]",
    body: "[data-cart-body]",
    subtotal: "[data-cart-subtotal]",
    count: "[data-cart-count]",
    toggle: "[data-cart-toggle]",
    close: "[data-cart-close]",
    addForm: 'form[action*="/cart/add"]',
    line: "[data-line-key]",
    qtyInput: "[data-qty-input]",
    qtyInc: "[data-qty-increase]",
    qtyDec: "[data-qty-decrease]",
    remove: "[data-line-remove]",
  };

  const money = (cents) => "₹" + (cents / 100).toFixed(2);

  function openDrawer() {
    const d = document.querySelector(SELECTORS.drawer);
    const b = document.querySelector(SELECTORS.backdrop);
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    if (b) b.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    const d = document.querySelector(SELECTORS.drawer);
    const b = document.querySelector(SELECTORS.backdrop);
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    if (b) b.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error("Cart fetch failed: " + res.status);
    return res.json();
  }

  async function renderDrawerBody(cart) {
    const body = document.querySelector(SELECTORS.body);
    const subtotal = document.querySelector(SELECTORS.subtotal);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<p class="ik-drawer__empty">The cart is quiet.<br/>Return to the shop when you are ready.</p>';
    } else {
      body.innerHTML = cart.items
        .map((item) => {
          const img = item.image
            ? `<img class="ik-drawer__line-img" src="${item.image}" alt="${item.product_title}" loading="lazy" width="80" height="96" />`
            : '<div class="ik-drawer__line-img"></div>';
          const variant =
            item.variant_title && item.variant_title !== "Default Title"
              ? `<p class="ik-drawer__line-variant">${item.variant_title}</p>`
              : "";
          return `
          <div class="ik-drawer__line" data-line-key="${item.key}">
            ${img}
            <div>
              <h3 class="ik-drawer__line-title">${item.product_title}</h3>
              ${variant}
              <div class="ik-drawer__line-qty">
                <button type="button" data-qty-decrease aria-label="Decrease quantity">−</button>
                <input type="text" value="${item.quantity}" data-qty-input readonly aria-label="Quantity" />
                <button type="button" data-qty-increase aria-label="Increase quantity">+</button>
              </div>
            </div>
            <div>
              <div class="ik-drawer__line-price">${money(item.final_line_price)}</div>
              <button type="button" class="ik-drawer__line-remove" data-line-remove>Remove</button>
            </div>
          </div>`;
        })
        .join("");
    }

    if (subtotal) subtotal.textContent = money(cart.total_price);

    document.querySelectorAll(SELECTORS.count).forEach((el) => {
      el.textContent = cart.item_count;
      el.setAttribute("data-count", cart.item_count);
    });

    const checkoutBtn = document.querySelector(".ik-drawer__checkout");
    if (checkoutBtn) {
      if (cart.item_count === 0) checkoutBtn.setAttribute("disabled", "");
      else checkoutBtn.removeAttribute("disabled");
    }
  }

  async function addToCart(formData) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    });
    if (!res.ok) {
      const err = await res
        .json()
        .catch(() => ({ description: "Add to cart failed" }));
      throw new Error(err.description || "Could not add item");
    }
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error("Change failed: " + res.status);
    return res.json();
  }

  document.addEventListener("click", async (e) => {
    const toggle = e.target.closest(SELECTORS.toggle);
    if (toggle) {
      e.preventDefault();
      try {
        const cart = await fetchCart();
        await renderDrawerBody(cart);
      } catch (err) {
        console.warn("[House of Reena] cart fetch:", err);
      }
      openDrawer();
      return;
    }

    if (
      e.target.closest(SELECTORS.close) ||
      e.target.closest(SELECTORS.backdrop)
    ) {
      closeDrawer();
      return;
    }

    const removeBtn = e.target.closest(SELECTORS.remove);
    if (removeBtn) {
      const line = removeBtn.closest(SELECTORS.line);
      if (!line) return;
      try {
        const cart = await changeLine(line.dataset.lineKey, 0);
        await renderDrawerBody(cart);
      } catch (err) {
        console.warn("[House of Reena] remove:", err);
      }
      return;
    }

    const incBtn = e.target.closest(SELECTORS.qtyInc);
    const decBtn = e.target.closest(SELECTORS.qtyDec);
    if (incBtn || decBtn) {
      const line = (incBtn || decBtn).closest(SELECTORS.line);
      if (!line) return;
      const input = line.querySelector(SELECTORS.qtyInput);
      const current = parseInt(input?.value || "0", 10);
      const next = incBtn ? current + 1 : Math.max(0, current - 1);
      try {
        const cart = await changeLine(line.dataset.lineKey, next);
        await renderDrawerBody(cart);
      } catch (err) {
        console.warn("[House of Reena] qty:", err);
      }
    }
  });

  document.addEventListener("submit", async (e) => {
    const form = e.target.closest(SELECTORS.addForm);
    if (!form || form.dataset.skipAjax === "true") return;
    e.preventDefault();
    try {
      await addToCart(new FormData(form));
      const cart = await fetchCart();
      await renderDrawerBody(cart);
      openDrawer();
    } catch (err) {
      console.warn("[House of Reena] add to cart:", err);
      form.submit();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });
})();
